import React, {ReactElement, useEffect, useState} from 'react';
import {FormGenContentItem, FormGenLayoutSource} from "./FormGenContainer";
import {ImageEditorImage, ImageEditorImageType, StyledCamera} from "./StyledCamera";
import {FileUtil} from "./file_util";
import {CircularProgress, Typography} from "@mui/material";

export enum FormGenCameraMode {
  CAPTURE,
  PREVIEW,
}

export function FormGenCamera(props: {
  mode?: FormGenCameraMode,
  contentItem: FormGenContentItem,
  source: FormGenLayoutSource,
  onDone?: () => void
}): ReactElement {
  const [initialImage, setInitialImage] = useState<ImageEditorImage>();
  const value: string = props.source.getValue(props.contentItem);
  const mode: FormGenCameraMode = props.mode;
  useEffect(() => {
    if (mode === FormGenCameraMode.PREVIEW && (value?.startsWith("blob:") || value?.startsWith("http:") || value?.startsWith("https:"))) {
      (async function () {
        try {
          const blob = await fetch(value).then(res => res.blob());
          const dataUrl = await FileUtil.blobToDataUrl(blob);
          if (dataUrl.startsWith("data:image/")) {
            setInitialImage({
              data: dataUrl,
              type: ImageEditorImageType.BASE64URL,
              cropped: true,
            });
          } else {
            setInitialImage(null);
          }
        } catch (e) {
          setInitialImage(null);
        }
      })();
    } else {
      setInitialImage(null);
    }
  }, [mode, value]);
  return initialImage !== undefined
    ? ((mode === undefined || mode === FormGenCameraMode.CAPTURE) || initialImage !== null
      ? <StyledCamera
        initialImage={initialImage}
        imageOptions={props.contentItem.metadata.imageOptions}
        imageEditor={props.contentItem.metadata.imageEditor}
        autoUpload={true}
        onUploadDone={(urls: string[]) => {
          props.source.setValue(props.contentItem, urls[0]);
        }}
        onDone={image => props.onDone?.()}
      />
      : <Typography>Unable to load image</Typography>)
    : <CircularProgress/>;
}